import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Globals } from '../models/globals.model';
import { Refinery } from '../models/refinery.model';
import { adminService } from '../services/admin.service';
import { GlobalService } from '../services/global.service';
import { RefineryService } from '../services/refinery.service';
import { ComponentModel } from '../models/component.model';
import { ComponentPageComponent } from '../view-page/component-page/component-page.component';
import { ConfirmModelComponent } from '../common/confirm-model/confirm-model.component';
import { AlertComponent } from '../common/alert/alert.component';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { FilterModel } from '../models/filter/filter-request.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FilterFieldTypes } from '../common/common-constants';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-component',
  templateUrl: './component.component.html',
  styleUrls: ['./component.component.scss']
})
export class ComponentComponent implements OnInit {
  isLoading = false;
  componentListDetails: any;
  refineryDetails: Refinery;
  selectedComponent: ComponentModel;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: any;
  @ViewChild('popOver') public popover: NgbPopover;
  searchText = '';
  displayedColumns: string[] = ['componentName', 'tenantName', 'lastModifiedBy', 'action'];
  destroyed = new Subject<any>();
  component: { refineryId: number; refineryName: string; refineryShortName: string; };

  constructor(
    public _router: Router,
    public globals: Globals,
    public globalService: GlobalService,
    public httpClientObj: HttpClient,
    private readonly adminService: adminService,
    private readonly refinaryService: RefineryService,
    public route: ActivatedRoute,
    public dialog: MatDialog) {
      const emptyList: any[] = [];
      this.componentListDetails = new MatTableDataSource(emptyList);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.getComponentList(this);
    this.getSearchText();
  }

  getSearchText() {
    this.route.params.subscribe((params: Params) => {
      if (params.searchText !== undefined) {
        this.searchText = params.searchText;
      }
    });
  }

  setSearchText(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();
    this.searchText = filterValue;
  }

  getComponentList(thisRef: ComponentComponent) {
    thisRef.selectedFilters = [];
    thisRef.isLoading = true;
    thisRef.refineryDetails = thisRef.refinaryService.getCurrentRefinery();
    thisRef.adminService.getComponentList(thisRef.refineryDetails?.refineryId).subscribe((data: any): void => {
      if (data && data !== null && data != undefined && data.length > 0) {
        thisRef.componentListDetails = new MatTableDataSource(data);
        thisRef.componentListDetails.filterPredicate=(data,filter:string): boolean=>{
          return data.tenantName.toLowerCase().includes(filter)||data.componentName.toLowerCase().includes(filter)||data.lastModifiedBy.toLowerCase().includes(filter);
        }
        thisRef.masterData = [...data];
        if (thisRef.filterList.length === 0) {
          thisRef.createFilterList();
        }
        thisRef.componentListDetails.sort = thisRef.sort;
        thisRef.componentListDetails.paginator = thisRef.paginator;
        if (thisRef.globalService.isNotNull(thisRef.searchText)) {
          thisRef.globalService.applyFilter(thisRef.searchText, thisRef.componentListDetails);
        }
        thisRef.isLoading = false;
      }
      else {
        thisRef.isLoading = false;
        thisRef.componentListDetails.data = [];
      }
    }, (error: Error) => {
      console.log('Error while fetching component list', error.message);
      thisRef.isLoading = false;
    });
  }

  openDialog(mode, element) {
    const dataToPass = { displayType: mode, data: element };
    this.globalService.openModelWindow(this.getComponentList, this, ComponentPageComponent, '80%', 'custom-modalbox', dataToPass);
    return true;
  }

  deleteModel(element) {
    const dataToPass = {
      title: 'Delete',
      isDelete: true,
      message: 'Do you really want to delete the component ' + element.componentName + '?'
    };
    this.selectedComponent = element;
    this.globalService.openModelWindow(this.deleteModelAfterConfirmation, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
  }

  /**
   * Displays confirmation after deletion
   * @param thisRef
   */
  deleteModelAfterConfirmation(thisRef: ComponentComponent) {
    thisRef.adminService.deleteComponent(thisRef.selectedComponent.componentId).subscribe(data => {
      if (data) {
        thisRef.globalService.showAlert(AlertComponent, { success: true, message: 'Component ' + thisRef.selectedComponent.componentName + ' deleted successfully!' });
        thisRef.getComponentList(thisRef);
        thisRef.isLoading = false;
      } else {
        thisRef.deleteFailed(thisRef);
      }
    }, error => {
      thisRef.deleteFailed(thisRef);
    });
  }

  deleteFailed(thisRef: ComponentComponent) {
    thisRef.globalService.showAlert(AlertComponent, { success: false, message: 'Component ' + thisRef.selectedComponent.componentName + ' could not be deleted!' });
    thisRef.getComponentList(thisRef);
    thisRef.isLoading = false;

  }

  createComponent() {
    const dataToPass = { displayType: 'add', data: {} };
    this.globalService.openModelWindow(this.getComponentList, this, ComponentPageComponent, '80%', 'custom-modalbox', dataToPass);
    return true;
  }

  // filter functionality code starts here

  /**
  * Returns data from child filter component
  * @param event
  */
  filterResponse(event) {
    const filterRes: FilterResponseModel = event.filterResponse;
    this.componentListDetails.data = this.globalService.conditionalDataFiltering(filterRes, this.componentListDetails.data);
    this.selectedFilters.push(filterRes);
    if (this.popover.isOpen()) {
      this.popover.close();
    }
  }

  /**Creates data for filter list */
  createFilterList() {
    for (let a = 0; a < this.displayedColumns.length - 1; a++) {
      const tempFilter: FilterModel = new FilterModel();
      let unique;
      tempFilter.fieldType = FilterFieldTypes.text;
      tempFilter.fieldName = this.globalService.replaceDisplayText(this.displayedColumns[a]);
      if (this.displayedColumns[a] === 'componentName') {
        unique = Array.from(new Set(this.componentListDetails.data.map(component => component.componentName)));
      } else if (this.displayedColumns[a] === 'tenantName') {
        unique = Array.from(new Set(this.componentListDetails.data.map(component => component.tenantName)));
      } else if (this.displayedColumns[a] === 'lastModifiedBy') {
        unique = Array.from(new Set(this.componentListDetails.data.map(component => component.lastModifiedBy)));
      }
      tempFilter.values = unique;
      this.filterList.push(tempFilter);
    }
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const i = this.selectedFilters.indexOf(selectedFilter);
    if (i >= 0) {
      this.selectedFilters.splice(i, 1);
      this.componentListDetails.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (const ele of this.selectedFilters) {
          this.componentListDetails.data = this.globalService.conditionalDataFiltering(ele, this.componentListDetails.data);
        }
      }
    }
  }


  // filter functionality code ends here

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

}
